import React, { FC } from 'react';
import { OHeaderThree, OSmallParagraph, Box, TimesIcon, IconSize } from '@lifechurch/react-ion';
import styled from 'styled-components';
import { ChopImage } from '@components/ChopImage';
import { buildStaticImageUrl } from '@utils/imgproxy';
import { useTranslation, Trans } from 'react-i18next';

interface Props {
  testId: string;
  closeClicked: () => void;
}

const Wrapper = styled.div`
  text-align: center;
  padding-block-start: 0;
  padding-inline-start: 12px;
  padding-inline-end: 12px;
  padding-block-end: 16px;
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
`;

const ChecklistComplete: FC<Props> = ({ closeClicked, testId }) => {
  const { t } = useTranslation('common');

  return (
    <Wrapper data-testid={testId}>
      <CloseButtonWrapper onClick={closeClicked} role='button'>
        <TimesIcon size={IconSize.SM} />
      </CloseButtonWrapper>
      <Box marginBlockStart={2}>
        <ChopImage
          height={40}
          src={buildStaticImageUrl('static/admin/first_steps_check.png')}
          width={40}
        />
      </Box>
      <OHeaderThree marginBlockStart={2}>{t('awesome')}</OHeaderThree>
      <OSmallParagraph marginBlockStart={3}>
        <Trans i18nKey='completed_all_steps'>
          You have completed all of the first steps. Now you can focus on what matters
          <br /> most—ministering to people!
        </Trans>
      </OSmallParagraph>
      <OSmallParagraph marginBlockStart={3}>
        <Trans>
          For more guidance, view our <a href='https://support.online.church'>support resources.</a>
        </Trans>
      </OSmallParagraph>
    </Wrapper>
  );
};

export default ChecklistComplete;
